// Stefans-AI-CV-frontend/src/sections/Footer.tsx

import { motion } from 'framer-motion'
import { useI18n } from '../i18n'
import { analyticsService } from '../services/analytics'

export default function Footer() {
  const t = useI18n()

  return (
    <footer className="py-12 border-t border-border relative overflow-hidden">
      {/* Subtle top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-cyan-400/30 to-transparent" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row items-center justify-between gap-8"
        >
          {/* Left: Logo + tagline */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 justify-center md:justify-start mb-2">
              <span className="font-heading font-bold text-xl text-text-primary">
                S<span className="text-cyan-400">.</span>
              </span>
              <span className="text-text-muted text-sm font-mono">{t.footer.tagline}</span>
            </div>
            <p className="text-text-muted text-xs max-w-xs">{t.footer.desc}</p>
          </div>

          {/* Center: Links */}
          <div className="flex items-center gap-6">
            <a
              href={`mailto:${t.footer.links.email}`}
              onClick={() => analyticsService.trackEvent('contact_click', {
                category: 'contact',
                label: 'email',
              })}
              className="flex items-center gap-2 text-text-secondary hover:text-cyan-400 transition-colors text-sm"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              <span>{t.footer.email_label}</span>
            </a>

            <a
              href={t.footer.links.aklabs}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => analyticsService.trackEvent('contact_click', {
                category: 'contact',
                label: 'aklabs_research',
                target_url: t.footer.links.aklabs,
              })}
              className="flex items-center gap-2 text-text-secondary hover:text-indigo-400 transition-colors text-sm"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
              </svg>
              <span>AKLabs Research</span>
            </a>
          </div>

          {/* Right: Copyright */}
          <div className="text-center md:text-right">
            <p className="text-text-muted text-xs">{t.footer.copyright}</p>
          </div>
        </motion.div>
      </div>
    </footer>
  )
}
